import { render, staticRenderFns } from "./activeHud.vue?vue&type=template&id=8971fb44&scoped=true"
import script from "./activeHud.vue?vue&type=script&lang=js"
export * from "./activeHud.vue?vue&type=script&lang=js"
import style0 from "./activeHud.vue?vue&type=style&index=0&id=8971fb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8971fb44",
  null
  
)

export default component.exports